import { NutritionData } from "../types/MealPlan";

export const getEnergyRatingBackgroundColor = (energyRating: string) => {
  switch (energyRating) {
    case "liberal":
      return "bg-liberal";
    case "moderate":
      return "bg-moderate";
    default:
      return "bg-keto";
  }
};

export const isEmptyNutritionData = (nutrition: NutritionData): boolean => {
  const percentages = nutrition.percentages || {};
  const values = nutrition.values || {};
  if (
    !percentages.carbs &&
    !percentages.fat &&
    !percentages.protein &&
    !values.calories &&
    !values.carbs &&
    !values.fat &&
    !values.fiber &&
    !values.protein
  ) {
    return true;
  }

  return false;
};

export const formatNutritionalValue = (value?: number | null) => {
  if (!value) {
    return "0";
  } else if (value >= 1) {
    return value.toFixed(0);
  } else if (value >= 0.01) {
    return (Math.round(value * 10) / 10).toString();
  } else {
    return (Math.round(value * 100) / 100).toString();
  }
};

export const formatCarbsValue = (value: number, decimalPlaces = 0) => {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(value * factor) / factor;
};
